import { GroupedUsers, SenderListInterface, User } from '../models/conversation.interface';
import { Dispatch } from 'react';
import { apiBaseUrl, networkCall } from '../../utils/networkCall';
export const LOAD_USER_DATA = 'LOAD_USER_DATA';
export const UPDATE_USER = 'UPDATE_USER';
export const NEW_USER = 'NEW_USER';
export const SELECTED_USER = 'SELECTED_USER';
export const DE_SELECTED_USER = "DE_SELECTED_USER";
export const UPDATE_USER_MODIFIED_TIME = "UPDATE_USER_MODIFIED_TIME";
export const LOAD_SENDER_LIST = "LOAD_SENDER_LIST";
export const SET_TO_INITIAL_STATE = "SET_TO_INITIAL_STATE";
interface UserState {
	users: GroupedUsers;
}

interface AddUserActionType {
	type: string;
	payload: User[];
}

interface UpdateUserActionType {
	type: string;
	userToUpdate: User;
}

interface NewUserActionType {
	type: string;
	userToAdd: User;
}

interface SelectedUserActionType {
	type: string;
	selectedUser: User;
}

interface DeSelectedUserActionType {
	type: string;
}

interface UpdateUserModifiedTimeActionType {
	type: string;
	updateTimeObj: any;
}

export function loadUserData(payload: User[]): AddUserActionType {
	return { type: LOAD_USER_DATA, payload: payload };
}

export function updateUser(userToUpdate: User): UpdateUserActionType {
	return { type: UPDATE_USER, userToUpdate: userToUpdate };
}

export function addNewUser(userToAdd: User): NewUserActionType {
	return { type: NEW_USER, userToAdd: userToAdd };
}

export function changeSelectedUser(selectedUser: User): SelectedUserActionType {
	return { type: SELECTED_USER, selectedUser };
}

export function deSelectedUser(): DeSelectedUserActionType {
	return { type: DE_SELECTED_USER };
}

export function updateTimeOfUser(updateTimeObj: any): UpdateUserModifiedTimeActionType {
	return { type: UPDATE_USER_MODIFIED_TIME, updateTimeObj }
}

export const OnNewUserArrived = (message: any) => {
	return (dispatch: Dispatch<any>, getState: () => any) => {
		const currState = getState();
		// append user object to user in redux
		const allUsers = currState.users.allIds;
		if (allUsers.includes(message.User.to_identifier)) {
			//update user
			dispatch(updateUser(message.User));
		} else {
			// new user
			dispatch(addNewUser(message.User));
		}
	};
};

export function loadSenderList(senderList: SenderListInterface) {
	return { type: LOAD_SENDER_LIST, senderList }
}

export function setToInitialState(): any {
	return { type: SET_TO_INITIAL_STATE };
};

export const getMediaUrl = (mediaUrl:string, callback: (resp: any, flag: boolean) => void) => {

    return () => {
        networkCall('GET', `/conversation/presigned-url?media-url=${mediaUrl}`, apiBaseUrl.baseUrl,true,true,undefined,undefined)
            .then((response: any) => {
                callback(response, true)
            })
            .catch((err: any) => { 
                console.log(err)
                callback(err, false)
            })
    }
}
